/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import * as _ from 'lodash';
import template from './third-party-audience-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {ThirdPartyAudienceModalService} from './third-party-audience-modal.service';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-third-party-audience-list-page',
  template
})
export class ThirdPartyAudienceListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adv.third-party-audiences.third-party-audience';
  readonly providers = ['NORDIC_DATA_RESOURCES', 'LC_MEDIA'];

  providerFilter = '';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'provider'},
    {param: 'externalReference'},
    {param: '', label: 'teams', sortable: false}
  ];

  private readonly hasManageSystem: boolean;

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any,
    private readonly thirdPartyAudienceModalService: ThirdPartyAudienceModalService
  ) {
    super(LocalNetworkProfile);
    this.hasManageSystem = LocalUserPermissions.hasNetworkPermission('MANAGE_SYSTEM');
  }

  applyProviderFilter(): void {
    const params = _.assign({}, this.list.moreParams);
    if (this.providerFilter) {
      params.filterBy = 'provider';
      params.filterByValue = this.providerFilter;
    } else {
      delete params.filterBy;
      delete params.filterByValue;
    }
    this.list.setMoreParams(params);
    this.list.makeQuery();
  }

  isAudienceReadOnly(audience: any): boolean {
    if (this.hasManageSystem) {
      return false;
    }
    if (_.isEmpty(audience.teams)) {
      return true;
    }
    return _.some(audience.teams, (team: any) => {
      return !this.LocalUserPermissions.has('MANAGE_AUDIENCES', team.id);
    });
  }

  hasData(audience: any): boolean {
    if (audience.provider && audience.metaData) {
      return _.get(audience.metaData, audience.provider) || null;
    }
    return false;
  }

  openAudienceUploadModal(uploadType: 'data' | 'definitions'): void {
    this.thirdPartyAudienceModalService.openUploadModal(uploadType, () => {
      this.list.makeQuery();
    });
  }
}
